exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-store-form {\n  width: 100%;\n  padding: 32px;\n}\n.create-store-form__form .ant-form-item {\n  width: 582px;\n}\n@media (max-width: 768px) {\n  .upload-store-photo {\n    width: 120px !important;\n  }\n}\n@media (min-width: 1024px) {\n  .upload-store-photo {\n    width: 212px !important;\n  }\n}\n.create-store-divider {\n  color: #a7a8aa;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n}\n.input-id-lotus {\n  width: 100px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/EditStore/components/CreateStoreForm/CreateStoreForm.less
// module id = 1189
// module chunks = 0